import { Link } from "react-router-dom";
import { LEGAL_OPERATOR } from "../content/legalMeta";
import "./LandingFooter.css";

export default function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__brand">
          <span className="landing-footer__logo">MOGAME</span>
          <p className="landing-footer__tagline">
            Обучение, база знаний и тренажёр в Telegram и MAX
          </p>
        </div>

        <nav className="landing-footer__nav" aria-label="Ссылки в подвале">
          <a href="#pricing">Тарифы</a>
          <a href="#faq">Вопросы</a>
          <Link to="/oferta">Оферта</Link>
          <Link to="/politic-confidencial">Политика конфиденциальности</Link>
          <Link to="/dlya-sotrudnika">Инструкция для сотрудников</Link>
        </nav>

        <div className="landing-footer__support">
          <p className="landing-footer__support-title">Поддержка</p>
          <a href={LEGAL_OPERATOR.telegramUrl} target="_blank" rel="noopener noreferrer">
            Telegram {LEGAL_OPERATOR.telegram}
          </a>
          <a href={`mailto:${LEGAL_OPERATOR.email}`}>{LEGAL_OPERATOR.email}</a>
          <span className="landing-footer__hours">Ежедневно 9:00–20:00 (МСК)</span>
        </div>
      </div>

      <div className="landing-footer__bottom">
        <span>© {new Date().getFullYear()} MOGAME</span>
      </div>
    </footer>
  );
}
